import React from 'react';
import { IconButton, Box } from '@chakra-ui/react';
import { UilApps } from '@iconscout/react-unicons';
import { UilListUl } from '@iconscout/react-unicons';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };

const GridSelector = ({ gridStyle, setGridStyle }) => {
	return (
		<Box d="flex" flexDir="row">
			<IconButton
				_hover={y300}
				_active={y400}
				_focus={y400}
				onClick={(e) => {
					setGridStyle('grid');
				}}
				isActive={gridStyle == 'grid' ? true : false}
				variant="outline"
				mx={1}
				aria-label="Grid Layout"
				icon={<UilApps size={14} />}
			/>
			<IconButton
				_hover={y300}
				_active={y400}
				_focus={y400}
				onClick={(e) => {
					setGridStyle('row');
				}}
				isActive={gridStyle == 'row' ? true : false}
				variant="outline"
				ml={1}
				aria-label="Lines Layout"
				icon={<UilListUl size={16} />}
			/>
		</Box>
	);
};

export default GridSelector;
